export default {
  setUsers (state, payload) {
    state.users = payload
  },
  addUser (state, payload) {
    state.users.push(payload)
  },
  updateUser (state, payload) {
    var index = state.users.findIndex(user => { return user.id === payload.id })
    state.users.splice(index, 1, payload)
  },
  deleteUser (state, payload) {
    var index = state.users.findIndex(user => { return user.id === payload.id })
    state.users.splice(index, 1)
  },
  setProjects (state, payload) {
    state.projects = payload
  },
  addProject (state, payload) {
    state.projects.push(payload)
  },
  updateProject (state, payload) {
    var index = state.projects.findIndex(project => { return project.id === payload.id })
    state.projects.splice(index, 1, payload)
  },
  deleteProject (state, payload) {
    var index = state.projects.findIndex(project => { return project.id === payload.id })
    state.projects.splice(index, 1)
  },
  setRoles (state, payload) {
    state.roles = payload
  },
  addRole (state, payload) {
    state.roles.push(payload)
  },
  updateRole (state, payload) {
    var index = state.roles.findIndex(role => { return role.id === payload.id })
    state.roles.splice(index, 1, payload)
  },
  deleteRole (state, payload) {
    var index = state.roles.findIndex(role => { return role.id === payload.id })
    state.roles.splice(index, 1)
  },
  setProject (state, payload) {
    state.projects = payload
  },
  setGNIPRules (state, payload) {
    state.gnipRules = payload
  },
  addGNIPRule (state, payload) {
    state.gnipRules.push(payload)
  },
  updateGNIPRule (state, payload) {
    var index = state.gnipRules.findIndex(gnipRule => { return gnipRule.tag === payload.tag && (payload.value ? gnipRule.value === payload.value : true) })
    state.gnipRules.splice(index, 1, payload)
  },
  deleteGNIPRule (state, payload) {
    var index = state.gnipRules.findIndex(gnipRule => { return gnipRule.tag === payload.tag && (payload.value ? gnipRule.value === payload.value : true) })
    state.gnipRules.splice(index, 1)
  },
  updateTheme (state) {
    state.theme = !state.theme
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js